import { twMerge } from "tailwind-merge";

import { getCookie, setCookie } from "cookies-next";
import { v4 as uuidv4 } from "uuid";
import isMobile from "ismobilejs";
import { getUTMParams } from "./utmParams";
import { getAppOsFromPlatformValue } from "./platformDetection.client";

export function cn(
  ...classes: (string | boolean | undefined | null)[]
): string {
  return twMerge(classes.filter(Boolean).join(" "));
}

export function getCookieValue(cookie: string, key: string) {
  if (!cookie?.includes(`${key}=`)) return;
  let retValue;
  const cookies = cookie.split(";");
  cookies.forEach((cookie) => {
    const [name, value] = cookie.trim().split("=");
    if (name === key) {
      retValue = value;
    }
  });
  return retValue;
}

export const getTrackerId = () => {
  const trackerid = getCookie("trackerid");
  if (typeof trackerid === "string" && trackerid) {
    return trackerid;
  } else if (!trackerid) {
    const newTrackerId = uuidv4();
    setCookie("trackerid", newTrackerId, {
      path: "/",
      domain: ".ackodrive.com",
      secure: true,
      sameSite: "lax",
      maxAge: 365 * 24 * 60 * 60,
    });
    return newTrackerId;
  }
  return "";
};

export const getPageReferrer = (): string => {
  if (typeof window !== "undefined") {
    return sessionStorage.getItem("pageReferrer") || "";
  }
  return "";
};

export const getExternalReferrer = (): string => {
  if (typeof window === "undefined") {
    return "";
  }

  const referrer = document.referrer;

  // No referrer = direct visit
  if (!referrer) {
    return "";
  }

  try {
    const referrerUrl = new URL(referrer);
    const hostname = referrerUrl.hostname.toLowerCase();

    // Check if it's from internal domains
    if (hostname.includes("ackodrive.com") || hostname.includes("acko.com")) {
      return "";
    }

    // External referrer - return just the domain
    return hostname;
  } catch {
    return "";
  }
};

export const getCurrentPageType = (): string => {
  if (typeof window === "undefined") {
    return "";
  }
  return sessionStorage.getItem("currentPageType") || "";
};

export const setCurrentPageType = (pageType: string): void => {
  if (typeof window !== "undefined" && pageType) {
    sessionStorage.setItem("currentPageType", pageType);
  }
};

export const getCustomerPhoneNumber = (): string => {
  if (typeof window === "undefined") {
    return "";
  }
  return getClientLoggedIn() ? sessionStorage.getItem("contact_number") || "" : "";
};

export const getClientLoggedIn = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }

  const refereshAccessToken = getCookie("ackodrive_tokens");

  if (typeof refereshAccessToken !== "string" || !refereshAccessToken) {
    return false;
  }

  try {
    const parsedTokens = JSON.parse(decodeURIComponent(refereshAccessToken));
    return (
      !!parsedTokens &&
      typeof parsedTokens === "object" &&
      Object.keys(parsedTokens).length > 0
    );
  } catch {
    return false;
  }
};

export const segmentEventCommonProp = () => {
  const isMobileDevice = isMobile(navigator?.userAgent).any;
  const isLoggedIn = getClientLoggedIn();
  const userTrackerId = getCookie("trackerid");
  const utm = getUTMParams(true) || {};
  const leadDataString = sessionStorage.getItem("leadData");
  const ip_city = sessionStorage?.getItem("ip_city");
  const leadData = leadDataString ? JSON.parse(leadDataString) : null;

  const fullName = isLoggedIn ? leadData?.first_name : "";
  const email = isLoggedIn ? leadData?.referrer_email : "";
  const mobileNumber = getCustomerPhoneNumber();

  let path = "";

  if (typeof window !== "undefined") {
    path = window.location.href || "";
  }

  const pageReferrer = getPageReferrer();

  const webviewCookie = getCookie("webview");
  const sourceCookie = getCookie("source");
  const platformCookieValue =
    (typeof webviewCookie === "string" && webviewCookie) ||
    (typeof sourceCookie === "string" && sourceCookie) ||
    "";

  return {
    lob: "ackodrive",
    customer_name: fullName || "",
    email: email || "",
    journey: "Home Page",
    logged_in: isLoggedIn ? true : false,
    // page: path,
    // path,
    phone: mobileNumber,
    platform: !isMobileDevice ? "web" : getCookie("webview") ? "app" : "mweb",
    os: getAppOsFromPlatformValue(platformCookieValue),
    // referrer: source,
    tracker_id: userTrackerId,
    search: "",
    url: path,
    utm_source: utm["utm_source"] || "",
    utm_campaign: utm["utm_campaign"] || "",
    utm_content: utm["utm_content"] || "",
    utm_medium: utm["utm_medium"] || "",
    from_page: pageReferrer,
    ip_city: ip_city || "",
  };
};
